/*
 * Copyright (c) Nexign, JSC, 2019-2025.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @author Alexander Golshtein
 * @author Nikolay Sviridov
 * @version 1.36.0
 * @since 1.1.0
 */
import {
    ICommonPageTableSetting,
    ICommonPageTranslation,
    ICommonPageTranslationTableField,
} from './common';

interface IPageBillsTranslation extends ICommonPageTranslation<IPageBillsTable, IPageBillsTitle> {
    tableFooter: IPageBillsTableFooter;
}

export default IPageBillsTranslation;

/**
 * @description Translation interface to personal account table.
 * @interface IPageBillsTable
 *
 */
export interface IPageBillsTable {
    accountNumber: ICommonPageTranslationTableField;
    amount: ICommonPageTranslationTableField;
    billDate: ICommonPageTranslationTableField;
    billDebt: ICommonPageTranslationTableField;
    billId: ICommonPageTranslationTableField;
    billNumber: ICommonPageTranslationTableField;
    billPaid: ICommonPageTranslationTableField;
    billPeriod: ICommonPageTranslationTableField;
    checked: ICommonPageTranslationTableField;
    clientId: ICommonPageTranslationTableField;
    clientName: ICommonPageTranslationTableField;
    contract: ICommonPageTranslationTableField;
    customer: ICommonPageTranslationTableField;
    disableCheckedAllMessage: string;
    fucturies: ICommonPageTranslationTableField;
    isPaid: ICommonPageTranslationTableField;
    paidAmount: ICommonPageTranslationTableField;
    paymentDate: ICommonPageTranslationTableField;
    payStatus: ICommonPageTranslationTableField;
    unpaidAmount: ICommonPageTranslationTableField;
}

interface IPageBillsTitle {
    disableExport: string;
    dropFilters: string;
    exportBtn: string;
    header: string;
    subTitles: IPageBillsSubTitle;
    tableSetting: ICommonPageTableSetting;
    helperText: string;
}

export enum EBillsTypeTranslation {
    bills = 'bills',
    billsAccount = 'billsAccount',
    billsUnpaid = 'billsUnpaid',
    billsUnpaidAccount = 'billsUnpaidAccount',
    wizardFastBillsDocSubtitle = 'wizardFastBillsDocSubtitle',
    wizardFastReportDocSubstitle = 'wizardFastReportDocSubstitle',
}

export interface IPageBillsSubTitle {
    [EBillsTypeTranslation.bills]: string;
    [EBillsTypeTranslation.billsAccount]: string;
    [EBillsTypeTranslation.billsUnpaid]: string;
    [EBillsTypeTranslation.billsUnpaidAccount]: string;
    [EBillsTypeTranslation.wizardFastBillsDocSubtitle]: string;
    [EBillsTypeTranslation.wizardFastReportDocSubstitle]: string;

}

interface IPageBillsTableFooter {
    basketTitle: string;
}
